import type { ICampaignUrlRedirectSetupGuide } from '../hooks/useCampaignUrlRedirectSetupGuide';

import { useCampaignUrlRedirectSetupGuide } from '../hooks/useCampaignUrlRedirectSetupGuide';
import { createContext, useContext } from 'react';

const CampaignUrlRedirectSetupGuideContext = createContext<ICampaignUrlRedirectSetupGuide | null>(
  null,
);

export const useCampaignUrlRedirectSetupGuideContext = (): ICampaignUrlRedirectSetupGuide => {
  const context = useContext(CampaignUrlRedirectSetupGuideContext);
  if (!context) {
    throw new Error(
      'useCampaignUrlRedirectSetupGuideContext must be used within a CampaignUrlRedirectSetupGuideProvider',
    );
  }

  return context;
};

export const CampaignUrlRedirectSetupGuideProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <CampaignUrlRedirectSetupGuideContext.Provider value={useCampaignUrlRedirectSetupGuide()}>
    {children}
  </CampaignUrlRedirectSetupGuideContext.Provider>
);
